// extracted by mini-css-extract-plugin
export default {"list":"MessagesList_list__r8Mkz"};